import { Spacing } from "@app/components";
import { Icon } from "@iconify/react";
import { Box, IconButton, Stack, Typography } from "@mui/material";
import React, { useState } from "react";

const UploadImages = ({
  selectedFrontViewImage,
  setSelectedFrontViewImage,
  selectedBackViewImage,
  setSelectedBackViewImage,
  selectedLeftSideViewImage,
  setSelectedLeftSideViewImage,
  selectedRightSideViewImage,
  setSelectedRightSideViewImage,
  selectedInteriorDashboardImage,
  setSelectedInteriorDashboardImage,
  selectedOdometerReadingImage,
  setSelectedOdometerReadingImage,
}: any) => {
  const frontRef = React.useRef<HTMLInputElement>(null);
  const backRef = React.useRef<HTMLInputElement>(null);
  const leftRef = React.useRef<HTMLInputElement>(null);
  const rightRef = React.useRef<HTMLInputElement>(null);
  const dashboardRef = React.useRef<HTMLInputElement>(null);
  const odometerRef = React.useRef<HTMLInputElement>(null);

  const renderPreview = (img: any) => {
    if (!img) return null;

    if (img instanceof File) {
      return (
        <img
          src={URL.createObjectURL(img)}
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      );
    }

    if (typeof img === "string") {
      return (
        <img
          src={img}
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      );
    }

    return null;
  };

  const renderBox = (
    label: string,
    ref: any,
    selectedImg: any,
    setImage: any
  ) => (
    <Stack sx={{ mb: 2, alignItems: "center", width: "46%" }}>
      <Box
        sx={{
          height: 140,
          border: "1px solid #5F5F5F",
          borderRadius: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: { xs: "100%", sm: "60%" },
          backgroundColor: "#F7F9FB",
          cursor: "pointer",
          overflow: "hidden",
          position: "relative",
        }}
        onClick={() => !selectedImg && ref.current?.click()}
      >
        {selectedImg ? (
          <>
            {renderPreview(selectedImg)}

            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                ref.current?.click();
              }}
              sx={{
                position: "absolute",
                top: 6,
                right: 6,
                background: "rgba(255,255,255,0.9)",
                width: 34,
                height: 34,
                boxShadow: 2,
                "&:hover": { background: "white" },
              }}
            >
              <Icon icon="solar:refresh-bold" width={20} />
            </IconButton>
          </>
        ) : (
          <>
            <Icon icon="mingcute:upload-line" width={40} color="#5F5F5F" />
            <Typography sx={{ color: "#1253FF" }}>Upload Image</Typography>
          </>
        )}
      </Box>

      <input
        type="file"
        accept="image/*"
        ref={ref}
        style={{ display: "none" }}
        onChange={(e) => {
          const file = e.target.files?.[0];
          if (file) setImage(file);
        }}
      />

      <Typography mt={1}>{label}</Typography>
    </Stack>
  );

  return (
    <Stack
      sx={{
        flexDirection: "row",
        width: "100%",
        flexWrap: "wrap",
        gap: 2,
      }}
    >
      {renderBox(
        "Front View",
        frontRef,
        selectedFrontViewImage,
        setSelectedFrontViewImage
      )}
      {renderBox(
        "Back View",
        backRef,
        selectedBackViewImage,
        setSelectedBackViewImage
      )}
      {renderBox(
        "Left Side View",
        leftRef,
        selectedLeftSideViewImage,
        setSelectedLeftSideViewImage
      )}
      {renderBox(
        "Right Side View",
        rightRef,
        selectedRightSideViewImage,
        setSelectedRightSideViewImage
      )}
      {renderBox(
        "Interior Dashboard",
        dashboardRef,
        selectedInteriorDashboardImage,
        setSelectedInteriorDashboardImage
      )}
      {renderBox(
        "Odometer Reading",
        odometerRef,
        selectedOdometerReadingImage,
        setSelectedOdometerReadingImage
      )}
    </Stack>
  );
};

export { UploadImages };
